import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { FileDownloadService } from '../../../../../services/file-download-service/file-download.service';
import { AppSettings } from '../../../../../utils/app-settings';
import { Message } from '../../models/message';
import { MessageAttachment } from '../../models/message-attachments';
import { MessageCountService } from '../../services/message-count-service/message-count.service';
import { MessagesService } from '../../services/message-service/messages.service';
declare const urlize:any;

@Component({
  selector: 'app-message-details',
  templateUrl: './message-details.component.html',
  styleUrls: ['./message-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageDetailsComponent extends ComponentBase implements OnInit {

  @Input() message: Message;
  @Input() folder: string;
  @Output() onReplyClick: EventEmitter<boolean> = new EventEmitter();
  selectedMessage: Message;
  processedMessageBody:string;
  loading: boolean = false;

  constructor(private messagesService: MessagesService
    , private messageCountService: MessageCountService
    , private fileDownloadService: FileDownloadService) {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (!this.message) {
      this.loading = true;
    }

    if (this.message) {
      this.loading = true;
      let subscription = this.messagesService.getMessageById(this.message.message_id, true, this.folder)
        .subscribe((res) => {
          this.selectedMessage = res;
          if(!res.is_html_body){
            this.processedMessageBody = this.processLinks(this.selectedMessage.body);
          }
          this.loading = false;
          if (!this.message.is_read) {
            this.message.is_read = true;
            this.messageCountService.getUnreadMessageCount();
          }
        });
      this.addSubscription(subscription);
    }
  }

  replyClicked() {
    this.onReplyClick.emit(true);
  }

  downloadAndOpenAttachment(message_id: number, attachment: MessageAttachment) {
    let url = AppSettings.apiUrl + "Messages/" + message_id + "/Attachments/" + attachment.message_attachment_id;
    this.fileDownloadService.downloadAndOpen(url, attachment.file_name, attachment.content_type).subscribe();
  }

  processLinks(text)
  {
    return urlize(text, {nofollow:true, autoescape:true, target:'_blank'} ) 
  }

}
